import CookieList from "./CookieList";
export default CookieList;
